import React, { useRef } from 'react';

// Carte cliquable dont un halo bleu suit le pointeur (variables CSS --mx/--my, voir .spotlight
// dans index.css). Aucun état React : le survol n'entraîne aucun rendu.
// `as` accepte une balise ('a', 'div') ou un composant qui transmet sa ref (Link de react-router).
export default function SpotlightCard({ as: Tag = 'div', className = '', children, ...rest }) {
  const ref = useRef(null);

  const onPointerMove = (event) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    el.style.setProperty('--mx', `${event.clientX - rect.left}px`);
    el.style.setProperty('--my', `${event.clientY - rect.top}px`);
  };

  return (
    <Tag ref={ref} onPointerMove={onPointerMove} className={`spotlight ${className}`} {...rest}>
      {children}
    </Tag>
  );
}
